import { createSelector } from 'reselect';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { restartWorkflow } from '../steps/actions';
import { sendBanklinkSms, clearTimer } from './actions';
import {
  selectCanResendSmsForBankConfirmation,
  selectSendSmsForBankConfirmation,
  selectMobileNumber,
} from '../../../selectors';
import Banklink from './Component';

const mapStateToProps = createSelector(
  selectMobileNumber,
  selectCanResendSmsForBankConfirmation,
  selectSendSmsForBankConfirmation,
  (mobileNumber, canResendSmsForBankConfirmation, sendSmsForBankConfirmation) => ({
    mobileNumber,
    canResendSmsForBankConfirmation,
    sendSmsForBankConfirmation,
  }),
);

const mapDispatchToProps = (dispatch) => ({
  sendBanklinkSms: () => dispatch(sendBanklinkSms()),
  restart: () => dispatch(restartWorkflow()),
  clearTimer,
});

export default connect(mapStateToProps, mapDispatchToProps)(Banklink);
